/**
 * UUIDv7 as defined in RFC 9562: 48-bit Unix timestamp in milliseconds followed by random bits.
 * IDs sort by creation time and may be generated on the client (ADR-0013), so offline-created
 * records keep their ID when they reach the server.
 */
export function uuidv7(now: number = Date.now()): string {
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  const view = new DataView(bytes.buffer);
  view.setUint16(0, Math.floor(now / 2 ** 32));
  view.setUint32(2, now >>> 0);
  view.setUint8(6, 0x70 | (view.getUint8(6) & 0x0f));
  view.setUint8(8, 0x80 | (view.getUint8(8) & 0x3f));

  let out = '';
  for (const [i, byte] of bytes.entries()) {
    if (i === 4 || i === 6 || i === 8 || i === 10) out += '-';
    out += byte.toString(16).padStart(2, '0');
  }
  return out;
}
